// In the future, We can consider
// using localForage and mutex for event queuing
// asyncronously, without queuing,it might have a
// bad performance effect when we have many events, but since we are just
// trying it out, I think we don't need it
// this gives us also the ability to even handle events in offline mode
// Usage
// import { segmentEventTracker } from 'utils/SegmentEventTracker'
// segmentEventTracker.trackEvent(EventName, payload);

import { isUndefined } from 'lodash';

const hasSegmentSDK = (window) => !!window.analytics && !!window.segmentContext

export class SegmentEventTracker {
  getTime;

  constructor({ getTime }) {
    window.segmentContext = window.segmentContext || {};
    this.getTime = getTime;
  }

  setContext(context) {
    window.segmentContext = {
      ...window.segmentContext,
      ...context,
    }
  }

  resetContext() {
    window.analytics.reset();
    window.segmentContext = {};
  }

  disableSendingEvent() {
    // TODO
    // remove this feature flag handler,
    // once we are ready to release segment
    if (!isUndefined(process.env.REACT_APP_DISABLE_SEGMENT) &&
      process.env.REACT_APP_DISABLE_SEGMENT === "true") {
      return true;
    }

    if (!hasSegmentSDK(window)) {
      return true;
    }

    // we dont want to flood segment
    // while working on FCA locally
    // since FCA recompiles everytime we are
    // changing a file and did mounts with
    // events will be expensive
    return window.location.hostname === 'localhost';
  }

  buildDefaultPayload(useDefaultPageName=false) {
    let payload;
    const { page_name } = window.segmentContext;

    payload = {
      path: window.location.pathname,
      triggered_at: this.getTime(),
    }

    if (useDefaultPageName) {
      payload = { ...payload, page_name }
    }

    return payload;
  }

  identify(userId, payload={}) {
    if (this.disableSendingEvent()) return false;

    window.analytics.identify(userId, {
      ...payload,
    });
  }

  // For page view event
  trackPageView(pageName, payload={}) {
    if (this.disableSendingEvent()) return false;

    window.analytics.page(pageName, {
      ...this.buildDefaultPayload(),
      ...payload,
    });
  }

  // For events like clicks, etc
  trackEvent(eventName, payload={}) {
    if (this.disableSendingEvent()) return false;

    // There will be pages where
    // we need to manually pass page_name
    let useDefaultPageName = true;
    if (payload.page_name) {
      useDefaultPageName = false;
    }

    window.analytics.track(eventName, {
      ...this.buildDefaultPayload(useDefaultPageName),
      ...payload,
    });
  }
}

export const segmentEventTracker = new SegmentEventTracker({
  getTime: () => new Date().toString(),
});



// WEBPACK FOOTER //
// ./src/utils/SegmentEventTracker.js